import { FieldValue, increment } from 'firebase/firestore';
import uniqid from 'uniqid';
import { Residues, Store, StoreLog, Worker } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  cafeSlug: string;
  newResidues: Residues;
  store: DbDocument<Store>;
  worker: DbDocument<Worker>;
  costDiff: Record<string, number>;
};

export const makeInventory = async ({ newResidues, costDiff, cafeSlug, store, worker }: Props) => {
  const batch = createBatch();

  if (store) {
    const diff: Record<string, number> = {};
    const updates: Record<`residues.${string}`, FieldValue> = {};

    Object.entries(newResidues).forEach(([id, qnt]) => {
      diff[id] = qnt - (store.residues[id] || 0);
      updates[`residues.${id}`] = increment(diff[id] || 0);
    });

    batch.update<Store>(`cafes/${cafeSlug}/stores/${store.id}`, updates);

    batch.set<StoreLog>(`cafes/${cafeSlug}/storeLogs/${uniqid()}`, {
      time: new Date().getTime(),
      workerId: worker.id,
      workerName: worker.name,
      storeId: store.id,
      type: 'inventory',
      diff,
      info: {
        type: 'inventory',
        newState: newResidues,
        oldState: store.residues,
        costDiff,
      },
    });
  }

  await batch.commit();
};
